/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCustomerRequest
 */
export interface UpdateCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    internalNote?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerRequest
     */
    marketingCommunication?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    birthDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCustomerRequest
     */
    tags?: Array<string>;
}

/**
 * Check if a given object implements the UpdateCustomerRequest interface.
 */
export function instanceOfUpdateCustomerRequest(value: object): value is UpdateCustomerRequest {
    return true;
}

export function UpdateCustomerRequestFromJSON(json: any): UpdateCustomerRequest {
    return UpdateCustomerRequestFromJSONTyped(json, false);
}

export function UpdateCustomerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCustomerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'internalNote': json['internalNote'] == null ? undefined : json['internalNote'],
        'marketingCommunication': json['marketingCommunication'] == null ? undefined : json['marketingCommunication'],
        'birthDate': json['birthDate'] == null ? undefined : json['birthDate'],
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}

export function UpdateCustomerRequestToJSON(json: any): UpdateCustomerRequest {
    return UpdateCustomerRequestToJSONTyped(json, false);
}

export function UpdateCustomerRequestToJSONTyped(value?: UpdateCustomerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'internalNote': value['internalNote'],
        'marketingCommunication': value['marketingCommunication'],
        'birthDate': value['birthDate'],
        'tags': value['tags'],
    };
}

